"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Setor = void 0;
const base_entity_1 = require("sol-orm-ts/dist/base-entity");
const typeorm_1 = require("typeorm");
let Setor = class Setor extends base_entity_1.CustomBaseEntity {
    constructor() {
        super(...arguments);
        this.cdSetor = void (0);
        this.cdSetorSuperior = void (0);
        this.cdEmpresa = void (0);
        this.cdResponsavel = void (0);
        this.nmSetor = void (0);
        this.stSetor = void (0);
        this.nmBairro = void (0);
        this.nmLogradouro = void (0);
        this.nrCep = void (0);
        this.nrEndereco = void (0);
        this.nmComplemento = void (0);
        this.nrTelefone = void (0);
        this.nmPontoReferencia = void (0);
        this.lgEstoque = void (0);
        this.nrRamal = void (0);
        this.idSetor = void (0);
        this.sgSetor = void (0);
        this.tpSetor = void (0);
        this.lgRecepcao = void (0);
        this.nrSetorExterno = void (0);
    }
};
__decorate([
    typeorm_1.Column('integer', { name: 'cd_setor', nullable: true }),
    __metadata("design:type", Number)
], Setor.prototype, "cdSetor", void 0);
__decorate([
    typeorm_1.Column('integer', { name: 'cd_setor_superior', nullable: true }),
    __metadata("design:type", Number)
], Setor.prototype, "cdSetorSuperior", void 0);
__decorate([
    typeorm_1.Column('integer', { name: 'cd_empresa', nullable: true }),
    __metadata("design:type", Number)
], Setor.prototype, "cdEmpresa", void 0);
__decorate([
    typeorm_1.Column('integer', { name: 'cd_responsavel', nullable: true }),
    __metadata("design:type", Number)
], Setor.prototype, "cdResponsavel", void 0);
__decorate([
    typeorm_1.Column('varchar', { name: 'nm_setor', nullable: true }),
    __metadata("design:type", String)
], Setor.prototype, "nmSetor", void 0);
__decorate([
    typeorm_1.Column('integer', { name: 'st_setor', nullable: true }),
    __metadata("design:type", Number)
], Setor.prototype, "stSetor", void 0);
__decorate([
    typeorm_1.Column('varchar', { name: 'nm_bairro', nullable: true }),
    __metadata("design:type", String)
], Setor.prototype, "nmBairro", void 0);
__decorate([
    typeorm_1.Column('varchar', { name: 'nm_logradouro', nullable: true }),
    __metadata("design:type", String)
], Setor.prototype, "nmLogradouro", void 0);
__decorate([
    typeorm_1.Column('varchar', { name: 'nr_cep', nullable: true }),
    __metadata("design:type", String)
], Setor.prototype, "nrCep", void 0);
__decorate([
    typeorm_1.Column('varchar', { name: 'nr_endereco', nullable: true }),
    __metadata("design:type", String)
], Setor.prototype, "nrEndereco", void 0);
__decorate([
    typeorm_1.Column('varchar', { name: 'nm_complemento', nullable: true }),
    __metadata("design:type", String)
], Setor.prototype, "nmComplemento", void 0);
__decorate([
    typeorm_1.Column('varchar', { name: 'nr_telefone', nullable: true }),
    __metadata("design:type", String)
], Setor.prototype, "nrTelefone", void 0);
__decorate([
    typeorm_1.Column('varchar', { name: 'nm_ponto_referencia', nullable: true }),
    __metadata("design:type", String)
], Setor.prototype, "nmPontoReferencia", void 0);
__decorate([
    typeorm_1.Column('integer', { name: 'lg_estoque', nullable: true }),
    __metadata("design:type", Number)
], Setor.prototype, "lgEstoque", void 0);
__decorate([
    typeorm_1.Column('varchar', { name: 'nr_ramal', nullable: true }),
    __metadata("design:type", String)
], Setor.prototype, "nrRamal", void 0);
__decorate([
    typeorm_1.Column('varchar', { name: 'id_setor', nullable: true }),
    __metadata("design:type", String)
], Setor.prototype, "idSetor", void 0);
__decorate([
    typeorm_1.Column('varchar', { name: 'sg_setor', nullable: true }),
    __metadata("design:type", String)
], Setor.prototype, "sgSetor", void 0);
__decorate([
    typeorm_1.Column('integer', { name: 'tp_setor', nullable: true }),
    __metadata("design:type", Number)
], Setor.prototype, "tpSetor", void 0);
__decorate([
    typeorm_1.Column('integer', { name: 'lg_recepcao', nullable: true }),
    __metadata("design:type", Number)
], Setor.prototype, "lgRecepcao", void 0);
__decorate([
    typeorm_1.Column('varchar', { name: 'nr_setor_externo', nullable: true }),
    __metadata("design:type", String)
], Setor.prototype, "nrSetorExterno", void 0);
Setor = __decorate([
    typeorm_1.Entity('grl_setor')
], Setor);
exports.Setor = Setor;
